import * as React from "react";

interface CloseIconProps {
  color?: string;
  width?: string;
  height?: string;
  className?: string;
  onClick?: () => void;
}

const SuccessIcon: React.FC<CloseIconProps> = ({
  color,
  width = "16",
  height = "16",
  className = "",
  onClick,
}) => {
  return (
    <div className={`${className}`} onClick={onClick}>
      <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
     
    >
      <path
        d="M3.332 9.668s1 0 2.333 2.333c0 0 3.706-6.11 7-7.333"
        stroke="#039855"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
    </div>
  );
};

export { SuccessIcon };
